export declare type ModalAction = 'add' | 'edit';
export declare type InviteType = 'BecomeDoctor';
export class InviteTypes {
    public static BecomeDoctor: InviteType = "BecomeDoctor";
}
